import { createAction, props } from '@ngrx/store';

export const googleMapsLoadStateUpdated = createAction('GOOGLE_MAPS_LOAD_STATE_UPDATED', props<{ isGoogleMapsLoaded: boolean }>());

